import { TspType } from '../model/tsp.types'

export const getSingleTspType = (payee: { features?: { category_web?: string } }) => {
  const types = payee.features?.category_web?.split(', ')

  if (!types) {
    return
  }

  if (types.includes(TspType.SERVICES)) {
    return TspType.SERVICES
  }

  if (types.includes(TspType.KEYS)) {
    return TspType.KEYS
  }

  if (types.includes(TspType.GAMES) && !types.includes(TspType.SERVICES)) {
    return TspType.GAMES
  }
}
